<template>
  <div class="content">
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>{{ $t("import_dialog_title") }}</md-dialog-title>

      <md-dialog-content>
        <form>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-100">
              <md-radio v-model="updateOrCreate" :value="0">Update</md-radio>
              <md-radio v-model="updateOrCreate" :value="1">Create</md-radio>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-100">
              <label for="uploadmyfile">
                <p>{{ $t("import_dialog_description") }}</p>
              </label>
              <input
                type="file"
                id="uploadmyfile"
                ref="file"
                @change="requestUploadFile"
              />
            </div>
          </div>
        </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="submitFile()"
          data-testid="import-button"
          >{{ $t("import_button") }}</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <p-s-table
          tableHeaderColor="purple"
          v-bind:title="$t('articles_title')"
          v-bind:subTitle="$t('articles_subtitle', { org: this.orgName })"
          showFilter="true"
          sortBy="customerArticleNumber"
          v-bind:actions="actions"
          v-bind:data="this.articles"
          v-bind:dict="this.articlesDict"
          v-bind:onFilterChanged="this.onFilterChanged"
        ></p-s-table>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-button v-if="renderSelfService"
          class="md-primary"
          style="float:right;"
          v-on:click="openImportModal()"
          data-testid="open-import"
          >{{ $t("import_button") }}</md-button
        >
        <md-button
          class="md-primary"
          style="float:right;"
          v-on:click="exportCSV()"
          data-testid="export-button"
          >{{ $t("export_button") }}</md-button
        >
      <md-button
          class="md-primary"
          style="float:right;"
          v-on:click="exportTemplate()"
          data-testid="export-template-button"
          >{{ $t("export_template_button") }}</md-button
        >
        </div>
    </div>
  </div>
</template>

<script>
import { PSTable } from "@/components";
import store from "@/store/index.js";
import helper from "@/util/helper";
import api from "@/api/api";

export default {
  name: "ArticleList",
  components: {
    PSTable,
  },
  data() {
    return {
      articles: [],
      file: "",
      articlesDict: [
        {
          key: "customerArticleNumber",
          label: "table_header_customer_article_number",
          type: "string",
        },
        {
          key: "customerArticleDescription",
          label: "table_header_customer_article_description",
          type: "string",
        },
        { key: "supplier", label: "table_header_supplier", type: "string" },
        { key: "container", label: "table_header_container", type: "number" },
        { key: "quantity", label: "table_header_amount", type: "number" },
      ],
      actions: [
        {
          action: this.openArticleDetails,
          icon: "search",
        },
      ],
      updateOrCreate: 0,
      showDialog: false,
    };
  },
  created() {
    store.commit("setLoading", true);

    api.getArticles().then((result) => {
      this.articles = result.data;

      store.commit("setLoading", false);
    });
  },
  computed: {
    orgName() {
      if (store.state.user.organizationName) {
        return store.state.user.organizationName;
      }

      return "";
    },
    renderSelfService() {
      return store.state.user.org == 5949363
    }
  },
  methods: {
    exportCSV() {
      let articles = store.state.articles.data;

      if (store.state.articleFilter !== null) {
        let filter = store.state.articleFilter;

        articles = articles.filter((article) => {
          return (
            article.customerArticleNumber
              .toString()
              .toLowerCase()
              .indexOf(filter) !== -1 ||
            article.customerArticleDescription
              .toString()
              .toLowerCase()
              .indexOf(filter) !== -1 ||
            article.supplier
              .toString()
              .toLowerCase()
              .indexOf(filter) !== -1 ||
            article.quantity
              .toString()
              .toLowerCase()
              .indexOf(filter) !== -1
          );
        });
      }

      if (articles.length === 0) {
        alert("In der aktuellen Filterung sind keine Artikel verfügbar.");
        return;
      }

      helper.export(articles, "article.csv");
    },
    exportTemplate() {
      let articles = store.state.articles.data;

      if (store.state.articleFilter !== null) {
        let filter = store.state.articleFilter;

        articles = articles.filter((article) => {
          return (
            article.customerArticleNumber
              .toString()
              .toLowerCase()
              .indexOf(filter) !== -1 ||
            article.customerArticleDescription
              .toString()
              .toLowerCase()
              .indexOf(filter) !== -1 ||
            article.supplier
              .toString()
              .toLowerCase()
              .indexOf(filter) !== -1 ||
            article.quantity
              .toString()
              .toLowerCase()
              .indexOf(filter) !== -1
          );
        });
      }

      var ids = articles.map(function(article) {return article.id;});
      
      api.postExportArticlesForImport(ids)
    },
    onFilterChanged(val) {
      store.commit("setArticleFilter", val);
    },
    openArticleDetails(item) {
      const id = item.id;
      let routeData = this.$router.resolve({
        name: "Artikeldetails",
        params: { id },
      });
      window.open(routeData.href, "_blank");
    },
    openImportModal() {
      this.showDialog = true;
    },
    requestUploadFile() {
      this.file = this.$refs.file.files[0];
      console.log(this.file);
    },
    submitFile() {
      let formData = new FormData();
      formData.append("file", this.file);

      if (this.updateOrCreate === 0) {
        //update
        api.putArticlesForImport(formData).then(() => {
          console.log("success");
        });
      } else {
        api.postArticlesForImport(formData).then(() => {
          console.log("success");
        });
      }
    },
  },
};
</script>
